import { SwipeableListItemContentContainer } from "./AfterSwipeContent.style";
import { AfterSwipContentType } from "./AfterSwipeContent.types";

export default function AfterSwipeContent(sideContent: AfterSwipContentType) {
    return (
        <SwipeableListItemContentContainer>
            <div className={`swipeable-list__item-content-center`}>
                <div className="swipeable-list__content">
                    <span className="swipeable-list__icon">
                        {sideContent.icon}
                    </span>
                    {sideContent.label && <span>{sideContent.label}</span>}
                </div>
            </div>
        </SwipeableListItemContentContainer>
    );
}
